import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import { WEB_PAYMENT_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import getWebPayments from "../../../../stores/auditor-store/web-payments";

const WebPaymentsData = withLiteObserverAndTheme(() => {
  const webPaymentArray = getWebPayments().webPaymentArray.get();

  return (
    <Et3Table
      columns={WEB_PAYMENT_HEADERS}
      rows={webPaymentArray}
      title={i18n.get("AUDITOR_WEB_PAYMENTS")}
      shouldBeFlagged={false}
      titleKey={"WEB_PAYMENTS"}
    />
  );
});
export default WebPaymentsData;
